import React, { useState } from 'react';
import Styled from '../styles/AdminFVContainer.styled';
import StyledForm from '../styles/FormFV.styled';
import { MdClose } from 'react-icons/md';
import Colors from 'enums/Colors';
import ReactQuill from 'react-quill';
import { Input, InputNumber, Switch } from 'antd';
import { IFormFVContainer } from '../interfaces/components/IFormFVContainer';
import ImagemPreviewFerramentaVideo from './ImagemPreviewFerramentaVideo';
import * as Yup from 'yup';

// Schema de validação Yup
const validationSchema = Yup.object().shape({
    title: Yup.string().required('Título é obrigatório').max(200, 'Máximo de 200 caracteres'),
    url: Yup.string().required('URL é obrigatória').max(50, 'Máximo de 50 caracteres'),
    altUrl: Yup.string().max(100, 'Máximo de 100 caracteres'),
    altFilepath: Yup.string().max(100, 'Máximo de 100 caracteres'),
    // outros campos se necessário
});

const FormFVPackage = ({ formVisible, handleSubmit, setForm, setFormVisible, form, handleChange, loading }: IFormFVContainer) => {
    const [base64, setBase64] = useState<string | null>(null);

    // Add a handler that matches the expected signature for onResetBase64
    const handleResetBase64 = () => {
        setForm((prev: any) => ({ ...prev, capaBase64: null, capaFilepath: null }));
        setBase64(null);
    };

    // Estado para erros de validação
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    // Novo handler para submit que valida com Yup antes de submeter
    const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            await validationSchema.validate(form, { abortEarly: false });
            setErrors({});
            handleResetBase64();
            handleSubmit(e);
        } catch (err: any) {
            if (err.inner) {
                const formErrors: { [key: string]: string } = {};
                err.inner.forEach((validationError: any) => {
                    if (validationError.path && !formErrors[validationError.path]) {
                        formErrors[validationError.path] = validationError.message;
                    }
                });
                setErrors(formErrors);
            }
        }
    };

    return (
        <StyledForm.FormPackage onSubmit={handleFormSubmit} active={formVisible}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="title">Título</Styled.Label>
                    <Input
                        size="large"
                        name="title"
                        id="title"
                        value={form.title}
                        onChange={handleChange}
                        maxLength={200}
                        showCount
                        required
                        placeholder="Digite o título"
                    />
                    {errors.title && <div style={{ color: 'red', fontSize: 12 }}>{errors.title}</div>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="nomenclature">Nomenclatura</Styled.Label>
                    <Input
                        size="large"
                        name="nomenclature"
                        id="nomenclature"
                        value={form.nomenclature}
                        onChange={handleChange}
                        maxLength={50}
                        showCount
                        placeholder="Digite a nomenclatura"
                    />
                    {errors.nomenclature && <div style={{ color: 'red', fontSize: 12 }}>{errors.nomenclature}</div>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="description">Descrição</Styled.Label>
                    <ReactQuill
                        value={form.description}
                        onChange={v => {
                            setForm((prev: any) => ({ ...prev, description: v }));
                        }}
                        placeholder="Digite a descrição"
                        style={{
                            backgroundColor: 'white',
                            color: 'black',
                        }}
                    />
                </Styled.FormGroup>
                <Styled.FormTwoGrid>
                    <Styled.FormGroup>
                        <Styled.Label htmlFor="url">URL</Styled.Label>
                        <Input
                            size="large"
                            name="url"
                            id="url"
                            value={form.url}
                            onChange={handleChange}
                            required
                            maxLength={50}
                            showCount
                            placeholder="Digite a URL"
                        />
                        {errors.url && <div style={{ color: 'red', fontSize: 12 }}>{errors.url}</div>}
                    </Styled.FormGroup>
                    <Styled.FormGroup>
                        <Styled.Label htmlFor="altUrl">Texto alternativo da URL</Styled.Label>
                        <Input
                            size="large"
                            name="altUrl"
                            id="altUrl"
                            value={form.altUrl}
                            onChange={handleChange}
                            maxLength={100}
                            showCount
                            placeholder="Digite o texto alternativo da URL"
                        />
                        {errors.altUrl && <div style={{ color: 'red', fontSize: 12 }}>{errors.altUrl}</div>}
                    </Styled.FormGroup>
                    <Styled.FormGroup>
                        <Styled.Label htmlFor="ordem">Ordenação</Styled.Label>
                        <InputNumber
                            min={1}
                            value={form.ordem}
                            onChange={value => setForm((prev: any) => ({ ...prev, ordem: value }))}
                            style={{ width: '100%' }}
                        />
                    </Styled.FormGroup>
                </Styled.FormTwoGrid>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="notUnit">Não possui unidade</Styled.Label>
                    <Switch
                        value={form.notUnit}
                        onChange={v => {
                            setForm((prev: any) => ({ ...prev, notUnit: v }));
                        }}
                        style={{
                            maxWidth: '14px',
                        }}
                    />
                </Styled.FormGroup>
                {/* <Styled.FormGroup>
                    <Styled.Label htmlFor="pounds">Pacote com acessibilidade em Libras</Styled.Label>
                    <Switch
                        checked={form.inPounds ?? true}
                        onChange={checked => setForm((prev: any) => ({ ...prev, inPounds: checked }))}
                        style={{ width: 40 }}
                    />
                </Styled.FormGroup> */}
                <Styled.Button type="submit">
                    {' '}
                    {loading ? <div className="loaderConteudo" style={{ width: '26px' }} /> : form.id > 0 ? 'Atualizar Pacote' : 'Criar Pacote'}
                </Styled.Button>
            </div>
            <div style={{ position: 'relative' }}>
                <MdClose
                    style={{ cursor: 'pointer', position: 'absolute', top: -20, right: 0 }}
                    size={32}
                    color={Colors.Blue}
                    onClick={() => setFormVisible(false)}
                />
                <Styled.FormGroup>
                    <Styled.FormGroup>
                        <Styled.Label htmlFor="altFilepath">Texto alternativo Imagem</Styled.Label>
                        <Input
                            size="large"
                            name="altFilepath"
                            id="altFilepath"
                            value={form.altFilepath}
                            onChange={handleChange}
                            maxLength={100}
                            showCount
                            placeholder="Digite o texto alternativo da imagem"
                        />
                        {errors.altFilepath && <div style={{ color: 'red', fontSize: 12 }}>{errors.altFilepath}</div>}
                    </Styled.FormGroup>
                    <Styled.Label htmlFor="tags">Imagem da capa</Styled.Label>
                    <ImagemPreviewFerramentaVideo
                        filepath={form.capaFilepath}
                        resetForm={handleResetBase64}
                        onBase64Change={base64 => setForm((prev: any) => ({ ...prev, capaBase64: base64 }))}
                        base64={base64 ?? ''}
                        setBase64={setBase64}
                    />
                </Styled.FormGroup>
            </div>
        </StyledForm.FormPackage>
    );
};

export default FormFVPackage;
